import React, { useState, useEffect } from "react";

import {
  Container,
  Content,
  Title,
  Pagination,
  Opcoes,
  Table,
  Button,
  Back,
} from "./styles";

import { withRouter } from "react-router-dom";
import swal from "sweetalert";

import {
  MdNavigateBefore,
  MdNavigateNext,
  MdDelete,
  MdAdd,
  MdCreate,
  MdKeyboardBackspace,
} from "react-icons/md";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import { producaov2 as api } from "../../../../services/apis";

import { Form, Input } from "semantic-ui-react";

const WebserieEpisodios = () => {
  const [episodios, setEpisodios] = useState(null);
  const [search, setSearch] = useState(null);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const deleteEpisodio = async (id) => {
    api
      .delete(`/admin/webserie/episodio/${id}`)
      .then((res) => {
        swal(
          `Deletado com sucesso - Live: ${res.data.confirmation.id} - ${res.data.confirmation.titulo} `
        );
        setReload(!reload);
      })
      .catch((err) => swal("Não foi possível deletar os dados", err.message));
  };

  useEffect(() => {
    if (search === "" || isNaN(search) || search === null) {
      let titulo;

      if (!search || search === "") {
        titulo = "%%";
      } else {
        titulo = `%${search}%`;
      }

      api
        .get(`/webserie/episodioFiltered?orderBy=id&titulo=${titulo}`)
        .then((res) => setEpisodios(res.data))
        .catch((err) =>
          swal("Não foi possível consultar os dados - ", err.message)
        );
    } else {
      api
        .get(`/webserie/episodio/${search}`)
        .then((res) => {
          setEpisodios(res.data);
        })
        .catch((err) =>
          swal("Não foi possível pegar os dados - ", err.message).then(
            (window.location.href = "/admin/webserie")
          )
        );
    }
  }, [search, reload]);

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title> Gerenciamento de Episodios</Title>
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Busque pelo episodio"
                placeholder="Busque pelo episodio"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
          <Button
              onClick={() =>
                window.open("/admin/webserie-episodio/criar", "_self")
              }
            >
              
              Criar
            </Button>
            </Form.Group>
          </Form>
          <Table>
            {episodios?.map((item) => (
              <tr>
                <td> {item.id || search} </td> <td> {item.titulo} </td>{" "}
                <td onClick={() => deleteEpisodio(item.id)}>
                  {" "}
                  <MdDelete />{" "}
                </td>{" "}
                <td
                  onClick={() =>
                    window.open(`/admin/webserie-episodio/update?${item.id}`)
                  }
                >
                  <MdCreate />
                </td>
              </tr>
            ))}
          </Table>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(WebserieEpisodios);
